"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InitialsSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29,24H3a1,1,0,0,0,0,2H29a1,1,0,0,0,0-2Z"/><path d="M6.707,20.29a1.008,1.008,0,0,1,0,1.42,1.014,1.014,0,0,1-1.42,0l-.79-.8-.79.8a1.014,1.014,0,0,1-1.42,0,1.008,1.008,0,0,1,0-1.42l.8-.79-.8-.79a1,1,0,0,1,1.42-1.42l.79.8.79-.8a1,1,0,0,1,1.42,1.42l-.8.79Z"/><path d="M18.967,20.74l-3.75-14a1,1,0,0,0-.97-.74h-.5a1,1,0,0,0-.97.74l-3.75,14a1,1,0,0,0,1.94.52l.88-3.29A.8.8,0,0,0,12,18h4a.8.8,0,0,0,.15-.03l.88,3.29A1,1,0,0,0,18,22a1.222,1.222,0,0,0,.26-.03A1.017,1.017,0,0,0,18.967,20.74ZM12.367,16,14,9.93,15.627,16Z"/><path d="M29.967,20.74l-3.75-14a1,1,0,0,0-.97-.74h-.5a1,1,0,0,0-.97.74l-3.75,14a1,1,0,0,0,1.94.52l.88-3.29A.8.8,0,0,0,23,18h4a.8.8,0,0,0,.15-.03l.88,3.29A1,1,0,0,0,29,22a1.222,1.222,0,0,0,.26-.03A1.017,1.017,0,0,0,29.967,20.74ZM23.367,16,25,9.93,26.627,16Z"/>';
var InitialsSVG = function InitialsSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.InitialsSVG = InitialsSVG;
InitialsSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(InitialsSVG);
exports.default = _default;